import React from 'react';

import type { PessoaMencionada } from '../../api/comentariosApi';

/**
 * O texto de um comentário com as menções destacadas (at-129).
 *
 * 🔴 Só é destacado o `@username` que o SERVIDOR confirmou como menção (`mencionados`). Um
 * `@qualquercoisa` digitado sem escolher no autocomplete fica como texto: destacá-lo faria a tela
 * afirmar que alguém foi avisado, quando ninguém foi.
 */
const TextoComMencoes: React.FC<{ texto: string; mencionados?: PessoaMencionada[] }> = ({
  texto,
  mencionados,
}) => {
  const conhecidos = (mencionados ?? []).filter((p) => p.username);
  if (conhecidos.length === 0) return <>{texto}</>;

  const porUsername = new Map(conhecidos.map((p) => [p.username!.toLowerCase(), p]));
  const nomes = conhecidos
    .map((p) => p.username!.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'))
    // Os mais longos primeiro: "@ana.lima" não pode ser cortado em "@ana".
    .sort((a, b) => b.length - a.length);
  const padrao = new RegExp(`@(${nomes.join('|')})(?=$|[\\s.,;:!?])`, 'gi');

  const partes: React.ReactNode[] = [];
  let ultimo = 0;
  let achado: RegExpExecArray | null;
  // `exec` em laço, não `matchAll`: o alvo do CRA não garante o `lib` ES2020.
  while ((achado = padrao.exec(texto)) !== null) {
    const inicio = achado.index;
    if (inicio > ultimo) partes.push(texto.slice(ultimo, inicio));
    const pessoa = porUsername.get(achado[1].toLowerCase());
    partes.push(
      <span key={`m-${inicio}`} className="comentarios-mencao" title={pessoa?.fullName ?? undefined}>
        {achado[0]}
      </span>,
    );
    ultimo = inicio + achado[0].length;
  }
  if (ultimo < texto.length) partes.push(texto.slice(ultimo));
  return <>{partes}</>;
};

export default TextoComMencoes;
